import * as React from "react"
import * as ReactDOM from "react-dom"
import * as Immutable from 'immutable'
import { default as Select } from 'react-select';

import { Room } from '../../types/types'

import * as RoomEventEmitter from './RoomEventEmitter'


type Props = {
  rooms: Room[],
  room: number
  source: string
  onRoomChange: (room: number) => void

}
type State = {}

declare var I18n: { t: (_:string) => string }

export default class RoomSelector extends React.Component<Props, State> {

  constructor(props, context) {
    super(props, context)
  }

  componentDidUpdate(prevProps : Props, prevState : State) {
    if (prevProps.room != this.props.room) {
      RoomEventEmitter.publish({ room_id: this.props.room, source: this.props.source})
    }
  }

  render() {
    return (
      <Select
        className="room-selector"
        name='bnb-rooms'
        value={this.props.room ? this.props.room.toString() : ""}
        placeholder={I18n.t("rental_adverts.booking_form.choose_room")}
        onChange={(option : {value: string}) => this.props.onRoomChange(parseInt(option.value))}
        options={this.props.rooms.map( (r) => { return {value: r.id.toString(), label: r.name} } )}
       />
    )
  }
}